// extracted by mini-css-extract-plugin
module.exports = {"container":"_8fcf41dc","containerFreeShippingTest":"_baff11ac","placeholder":"_d42404b8"};